<mat-menu #childMenu="matMenu" [overlapTrigger]="false">
    <span *ngFor="let category of items">
      <!-- Handle branch node menu items -->
      <span *ngIf="category.childs && category.childs.length > 0">
        <button mat-menu-item color="primary" [routerLink]="['/buscar/categoria/'+ category.id +'/' + category.title]" [matMenuTriggerFor]="menu.childMenu">
          <span>{{category.title}}</span>
        </button>
        <app-menu-nested-item #menu [items]="category.childs"></app-menu-nested-item>
      </span>
      <!-- Handle leaf node menu items -->
      <span *ngIf="!category.childs || category.childs.length === 0">
        <button mat-menu-item [routerLink]="['/buscar/categoria/'+ category.id +'/' + category.title]">
          <span>{{category.title}}</span>
        </button>
      </span>
    </span>
  </mat-menu>